import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './WhySosOwner.module.css';
import {ReactComponent as Qualified} from '../../assets/svg/qualified.svg';
import { ReactComponent as Quick } from '../../assets/svg/quickanother.svg';
import { ReactComponent as Inclusive }from '../../assets/svg/all_include.svg';
import hasslefree from '../../assets/svg/hassleFree.svg';
import {ReactComponent as Riskfree} from '../../assets/svg/riskfree.svg';
import {ReactComponent as Octagon} from '../../assets/svg/octagonWithExclamation.svg';

export default function WhySosOwner() {
  return (
    <>
      <div className={css.BusinessOwnerWrap}>
        <div className={css.WhySosOwnerMain}>
          <p className={css.heading}>
            {' '}
            <FormattedMessage id="WhySosOwner.Heading" />{' '}
          </p>
          <div className={css.WhySosOwnerBoxContainer1}>
            <div className={css.boxItem}>
              <div className={css.icondiv}>
                <Qualified/>
              </div>
              <div className={css.boxItemDescContainer}>
                <h3 className={css.title}>
                  {' '}
                  <FormattedMessage id="WhySosOwner.Qualified" />{' '}
                </h3>
                <p className={css.about}>
                  <FormattedMessage id="WhySosOwner.QualifiedAbout" />
                </p>
              </div>
            </div>
            <div className={css.boxItem}>
              {/* <div className={css.icondiv}>  */}
                <Quick  />
              {/* </div> */}
              <div className={css.boxItemDescContainer}>
                <h3 className={css.title}>
                  <FormattedMessage id="WhySosOwner.Quick" />{' '}
                </h3>
                <p className={css.about}>
                  {' '}
                  <FormattedMessage id="WhySosOwner.QuickAbout" />{' '}
                </p>
              </div>
            </div>
            <div className={css.boxItem}>
              <div className={css.icondiv}>
                <Inclusive className={css.inclusive} />
              </div>
              <div className={css.boxItemDescContainer}>
                <h3 className={css.title}>
                  <FormattedMessage id="WhySosOwner.Inclusive" />
                </h3>
                <p className={css.about}>
                  <FormattedMessage id="WhySosOwner.InclusiveAbout" />{' '}
                </p>
              </div>
            </div>

            <div className={css.boxItem}>
              <div className={css.icondiv}>
                <Octagon className={ css.octagon} />
              </div>
              <div className={css.boxItemDescContainer}>
                <h3 className={css.title}>
                  <FormattedMessage id="WhySosOwner.Hassle" />
                </h3>
                <p className={css.about}>
                  {' '}
                  <FormattedMessage id="WhySosOwner.HassleAbout" />
                </p>
              </div>
            </div>
            <div className={css.boxItem}>
              <div className={css.icondiv}>
                <Riskfree/>
              </div>
              <div className={css.boxItemDescContainer}>
                <h3 className={css.title}>
                  <FormattedMessage id="WhySosOwner.Risk" />
                </h3>
                <p className={css.about}>
                  {' '}
                  <FormattedMessage id="WhySosOwner.RiskAbout" />{' '}
                </p>
              </div>
            </div>
          </div>
          {/* <div className={css.WhySosOwnerBoxContainer2}>
            <div className={css. boxItem}>
            <div className={css.icondiv}>
                        <img src={hasslefree} alt="" />
                </div>
                <div className={css.boxItemDescContainer}>
                    <h3 className={css.title} ><FormattedMessage id='WhySosOwner.Hassle'/></h3>
                    <p className={css.about}> <FormattedMessage id='WhySosOwner.HassleAbout'/></p>
                </div>
            </div>
            <div className={css. boxItem}>
            <div className={css.icondiv}>
                        <img src={riskfree} alt="" />
                </div>
                <div className={css.boxItemDescContainer}>
                    <h3 className={css.title} ><FormattedMessage id='WhySosOwner.Risk'/></h3>
                    <p className={css.about}> <FormattedMessage id='WhySosOwner.RiskAbout'/> </p>
                </div>
            </div>
             
        </div> */}
        </div>
      </div>
    </>
  );
}
